module.exports = __webpack_public_path__ + "static/img/3558_phase_function_Paper_PointsHejduk_Prediction.eafd43b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3558_phase_function_Paper_PointsHejduk_Prediction.png
// module id = HNjI
// module chunks = 0